<template>
  <div class="block-container" :class="{gray}">
    <div class="left-part">
      <img height="20" width="20" :src="'https://toolkit.cmem-mat.info/newsletter/caret-' + (this.progress > 0 ? 'up' : 'down') + '-solid.svg'" />
      <small :class="{green: this.progress > 0, red: this.progress < 0 }">{{isProgressPercent ? formatPercent(progress) : formatNb(progress)}}</small>
    </div>
    <div class="right-part">
      <span>{{this.title}}</span>
      <span class="value">{{isValuePercent ? (value + "%") : value}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsletterDataBlock",
    props: ["title", "progress", "value", "gray", "isProgressPercent", "isValuePercent"],
    methods: {
      formatPercent(val) {
        return (val / 100).toLocaleString("fr-FR", {
          style: "percent",
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }).replace(/\s/g, "");
      },
      formatNb(val) {
        return val.toLocaleString("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
    }
  }

</script>

<style scoped>
  .block-container {
    max-width: 162px;
    display: flex;
    column-gap: 16px;
    flex-wrap: nowrap;
    padding: 4px;
    background-color: #FFF;
    margin-top: 6px;
  }

  .block-container.gray {
    background-color: #e5e7ed;
  }

  .left-part {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 1;
    font-size: 0.9rem;
  }

  .right-part {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;

  }

  .right-part span {
    white-space: nowrap;
    text-align: right;
  }

  .right-part .value {
      font-size: 1.4em;
  }

  .green {
    color: var(--color);
  }

  .red {
    color: #C66;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Adherent/Newsletter/DataBlock.vue